<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-file-list-3-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Fiche technique : matières premières</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                    <div class="box-body" v-if="isdisplayviewarticle===false">
                        <div class="border-b-0 border-gray-200 dark:border-white/10">
                            <nav class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" aria-label="Tabs">
                                <button type="button" class="hs-tab-active:bg-white hs-tab-active:border-b-transparent
                                                hs-tab-active:text-primary dark:hs-tab-active:bg-transparent dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-primary -mb-px py-2 px-3
                                                 inline-flex items-center gap-2 bg-gray-50 text-sm font-medium text-center border text-defaulttextcolor rounded-t-sm hover:text-primary
                                                 dark:bg-black/20 dark:border-white/10 dark:text-[#8c9097] dark:text-white/50 dark:hover:text-gray-300 active"
                                        id="hs-tab-js-behavior-item-1" data-hs-tab="#hs-tab-js-behavior-1" aria-controls="hs-tab-js-behavior-1">
                                    Information de base
                                </button>



                            </nav>
                        </div>

                        <div class="">
                            <div id="hs-tab-js-behavior-1" role="tabpanel" aria-labelledby="hs-tab-js-behavior-item-1" class="">


                                <div v-if="messagesucces!==''" class="mt-4 mb-4 alert alert-success !border-success/10 flex items-center" role="alert">

                                    <div>
                                       {{messagesucces}}
                                    </div>
                                </div>

                                <div v-if="messageerror!==''" class="mt-4 mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">

                                    <div>
                                       {{messageerror}}
                                    </div>
                                </div>


                                <div class="ti-custom-validation mt-5" >

                                    <div class="xl:col-span-12  col-span-12">
                                         <div class="xl:col-span-12  col-span-12" >
                                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">ARTICLE</label>

                                               <input :value="Items.article" type="text" class="form-control" disabled>
                                            </div>

                                    </div>


                                    <div class="grid grid-cols-12  gap-x-6 mt-3">

                                        <div class="xl:col-span-10  col-span-12">

                                            <div class="grid grid-cols-12  gap-x-6 mt-3">
                                                <div class="xl:col-span-11  col-span-11" >
                                                    <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">ARTICLE (Matière première)</label>
                                                           <input :value="Itemsfiche.libelle" type="text" class="form-control" disabled>
                                                </div>
                                                <div class="xl:col-span-1  col-span-1">
                                                    <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">&nbsp;</label>

                                                    <button v-if="!disabled" @click="btnmodallistedesarticles('vente')"   class="ti-btn ti-btn-success-full ti-btn-lg ti-btn-wave">...</button>
                                                    <button v-else disabled  class="ti-btn ti-btn-success-full ti-btn-lg ti-btn-wave">...</button>


                                                </div>

                                            </div>

                                        </div>
                                        <div class="xl:col-span-2  col-span-12 mt-3">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Portion en {{Itemsfiche.unite}}</label>

                                            <input  v-model="Itemsfiche.portion" type="number" min="0"  class="form-control text-center" >


                                        </div>


                                    </div>

                                    <hr class="mb-[-15px]">
                                    <div class="clearfix"></div>
                                    <div class="form-group mt-[20px]">
                                        <div class="row flex justify-end">
                                            <div class="grid grid-cols-3 gap-x-6 mt-3">

                                                <button @click="newArticle" class="ti-btn ti-btn-primary-full mt-2 mx-[6px]">
                                                    <i class="ri-add-fill"></i> Nouveau
                                                </button>
                                                <button @click="SaveArticle()" class="ti-btn ti-btn-success-full mt-2 mx-[6px]" >
                                                    <i class="ri-check-line"></i> Enregistrer
                                                </button>
                                                <button @click="deleteItemArticle()" class="ti-btn ti-btn-danger-full mt-2 mx-[6px]" >
                                                    <i class="ri-delete-column"></i> Supprimer
                                                </button>

                                            </div>
                                        </div>
                                    </div>



                                    <div class="box-body !p-0 mybodyheight300px">
                                        <div class="table-responsive">

                                            <!-- component -->

                                            <div class="flex flex-col h-screen">
                                                <div class="flex-grow overflow-auto">




                                                    <table class="relative w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col" class="th text-start">N°</th>
                                                            <th scope="col" class="th text-start" colspan="2">Article (Matière première)</th>
                                                            <th scope="col" class="th text-start">Unité</th>
                                                            <th scope="col" class="th text-start">Portion</th>
                                                            <th scope="col" class="th text-start">ACTION</th>

                                                        </tr>
                                                        </thead>
                                                        <tbody>

                                                        <template v-if="listedatatable.length">

                                                            <template  v-for="(datavalue,index) in listedatatable" :key="index">
                                                                <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light">

                                                                    <td data-label="N°  : ">{{index+1}}</td>
                                                                    <td  data-label="DESIGNATION  : " colspan="2"  >{{ datavalue.matiere.libelle }}</td>
                                                                    <td  data-label="UNITE  : "   >{{ datavalue.matiere.unite }}</td>
                                                                    <td  data-label="PORTION  : "   >{{ datavalue.qte }}</td>
                                                                    <td  data-label="ACTION  : "   >

                                                                        <button   @click="modifierArticle(datavalue)"  aria-label="anchor"
                                                                                  class="ti-btn ti-btn-primary-full">
                                                                            <i class="ri-check-line"></i> Sélectionner
                                                                        </button>
                                                                    </td>

                                                                </tr>
                                                                <tr v-if="datavalue.etatline===2">
                                                                    <td colspan="6"><div class="alert alert-danger text-center">{{datavalue.linemessage}}</div></td>
                                                                </tr>

                                                            </template>



                                                        </template>


                                                        <template v-else>
                                                            <tr >
                                                                <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                                            </tr>

                                                        </template>



                                                        </tbody>
                                                    </table>


                                                </div>
                                            </div>

                                        </div>
                                    </div>







                                </div>
                            </div>



                        </div>
                    </div>




                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    <button v-if="isdisplayviewarticle===true" class="ti-btn ti-btn-primary-full" @click="close">Appliquer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <modallistedesarticles @elementSelectionnearticle="handleElementSelectedarticle" ref="modallistedesarticles"></modallistedesarticles>


</template>

<script>
   /* import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/definition/menu";*/
   // import allfunction from "@/allfunction";
   import { randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
   import modallistedesarticles from "@/components/views/pages/stock/fichetechnique/modal_listedesmatierepremiere";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {


        },

        computed:{


        },
        components: {
           /* templatesite,
            appheader,
            appsidebar,
            appmenu,*/

            modallistedesarticles

        },

        data() {
            return {
                isdisplayviewarticle:false,
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                titlemodal:"",
                typedoc:"",
                typeaction:"add",
                Items: {},
                alldata: [],

                listedatatable:[],
                listedatatableproduit:[],
                mydocmag:'',


                Itemsfiche:{
                    pid:'',
                    libelle:'',
                    unite:'',
                    portion:0,
                    etatline:1,

                }


            };
        },
        methods: {

            btnmodallistedesarticles(option){

                let listedatable=[],
                    titlemodal="Liste des Articles (Matière première)",
                    typedoc="";

                this.$refs.modallistedesarticles.show(titlemodal,option,this.listedatatableproduit,this.Items.pidmag);

            },

            handleElementSelectedarticle(elementSelectionne) {



                if (elementSelectionne.value!==null){

                    this.Itemsfiche.libelle=elementSelectionne.value.libelle
                    this.Itemsfiche.pid=elementSelectionne.value.pid
                    this.Itemsfiche.unite=elementSelectionne.value.unite


                }
                else{
                    this.Itemsfiche={
                        pid:'',
                        libelle:'',
                        unite:'',
                        portion:0,
                        etatline:1,

                    }
                }

               // this.changeItem(this.ItemsArticle.article)

            },

            close(){

                this.listedatatableproduit=[];
                this.listedatatable=[];

                this.isdisplay=false;

                this.$emit('closed');

            },

            show(titlemodal,typeaction,Items){

                this.titlemodal=titlemodal
                this.typeaction=typeaction
                this.Items=Items
                this.messagesucces="";
                this.messageerror="";
                this.newArticle();
                this.disabled=false;
                this.loadfichetechnique(Items.pidar)

                this.isdisplay=true;

            },

            newArticle(){
                this.Itemsfiche={
                        pid:'',
                        libelle:'',
                        unite:'',
                        portion:0,
                        etatline:1,

                }
                this.disabled=false;
            },


            modifierArticle(value){

                let t=this;

                this.Itemsfiche={
                    pid:value.matiere.pid,
                    libelle:value.matiere.libelle,
                    unite:value.matiere.unite,
                    portion:value.qte,
                    etatline:value.etatline,

             }


                this.disabled=true;

            },

            changeItem(value){

                let pid=this.ItemsArticle.pid;
               // let value=event;
                if (pid!=='') return;
                let dataSearch=[];

                if(value!==null){

                    if(this.listedatatable.length !==0){


                        dataSearch = this.listedatatable.filter(function (article) {

                            return  article.pidar ===value.pid
                            //return article.pidar.includes(value.pid);
                        });


                        if(dataSearch.length !==0){
                            toastr['error']( value.libelle+' existe déjà dans la liste.',"<b></b>");
                            this.ItemsArticle.article=null;
                            this.ItemsArticle.qtite=0;
                            this.ItemsArticle.pu= 0
                        }else{




                        }


                    }else{




                    }


                }


            },



            async SaveArticle(){



                if (this.Itemsfiche.pid===""){

                  toastr['error']( 'Veuillez sélectionner ARTICLE (Matière première)',"<b></b>");
                    this.$store.dispatch('lancerchargement',false)
                    return;
                }

                if (this.Itemsfiche.portion<=0){

                  toastr['error']( 'Veuillez saisir la portion',"<b></b>");
                    this.$store.dispatch('lancerchargement',false)
                    return;
                }


                let mitems={
                    article:{
                        pid:this.Items.pidar,
                        libelle:this.Items.article,
                        unite:this.Items.unite,
                    },
                    matiere:{
                        pid:this.Itemsfiche.pid,
                        libelle:this.Itemsfiche.libelle,
                        unite:this.Itemsfiche.unite,
                    },

                    pidar:this.Items.pidar,
                    pidmag:this.Items.pidmag,
                    pidfich:this.Itemsfiche.pid,
                    portion:this.Itemsfiche.portion,
                    etatline:this.Itemsfiche.etatline,


                }

                let t=this;

               let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/add/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .post(url,mitems,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                     let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        //  t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){


                            toastr['success']( res.data.message,"<b></b>");

                              t.newArticle();

                            //t.itemArticle.pid=res.data.key
                            // t.listedatatable=res.data.alllignedoc;
                            //  t.itemDoc.mtnt=res.data.mtnt;

                            t.loadfichetechnique(t.Items.pidar)

                        }
                        else{


                            toastr['error']( res.data.message,"<b></b>");
                            //  t.$store.dispatch('lancerchargement',false)




                        }


                    })
                    .catch(function (error) {
                        toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>");



                    })
                    .finally(function () {
                        //this.$store.dispatch('lancerchargement',false);

                        /*this.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.linekey=2;

                            }

                        })*/


                    } )







            },


            async deleteItemArticle(){

                if (this.Itemsfiche.pid===""){

                    toastr['error']( 'Veuillez sélectionner ARTICLE (Matière première)',"<b></b>");
                    this.$store.dispatch('lancerchargement',false)
                    return;
                }

                if (this.Itemsfiche.portion<=0){

                    toastr['error']( 'Veuillez saisir la portion',"<b></b>");
                    this.$store.dispatch('lancerchargement',false)
                    return;
                }


                let mitems={
                    article:{
                        pid:this.Items.pidar,
                        libelle:this.Items.article,
                        unite:this.Items.unite,
                    },
                    matiere:{
                        pid:this.Itemsfiche.pid,
                        libelle:this.Itemsfiche.libelle,
                        unite:this.Itemsfiche.unite,
                    },

                    pidar:this.Items.pidar,
                    pidfich:this.Itemsfiche.pid,
                    portion:this.Itemsfiche.portion,
                    etatline:this.Itemsfiche.etatline,


                }

                let t=this;

                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/deleteline/'+this.$store.state.appsociete+'/'+randomString();
                  let response =   axios  .post(url,mitems,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })



                let res= await response
                    .then(function (res){


                        if(res.data.success){


                            toastr['success']( res.data.message,"<b></b>");


                            t.newArticle();

                            t.loadfichetechnique(t.Items.pidar)


                        }
                        else{


                            toastr['error']( res.data.message,"<b></b>");
                            //  t.$store.dispatch('lancerchargement',false)

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>")
                    )
                    .finally()




            },



            async  loadfichetechnique($pidar){


                  this.$store.dispatch('lancerchargement',true)

                  const t = this;
                  let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/getall/'+$pidar+'/'+this.$store.state.appsociete+'/'+randomString();
                  let response =   axios  .get(url,{
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': 'Bearer ' + JwtService.getToken(),
                          'csrftoken': this.$store.state.appsociete
                      } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                  })

                  let res= await response
                        .then(function (res){
                           // t.$store.dispatch('beartoken',res.data.beartoken)
                            t.$store.dispatch('lancerchargement',false)
                            t.listedatatable=[];
                            if(res.data.success){

                                t.listedatatable=res.data.m;

                            }
                              else{
/*
                               let errormessage="";

                                t.messageerror="";
                                t.messagesucces="";
                                if (res.data.datamessage.length>0){

                                    for (let message of res.data.datamessage){

                                        if (errormessage===""){

                                            errormessage=message;

                                        }else{

                                            errormessage+=" , "+message;

                                        }


                                    }


                                    t.messageerror=errormessage;

                                }
                                else{
                                    t.messageerror=res.data.message
                                }


                                toastr['error'](t.messageerror,"<b></b>");*/
                            }


                        })
                        .catch(

                            error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                                "<b>Erreur</b>")
                        )
                        .finally(() => this.$store.dispatch('lancerchargement',false))


                },



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>